export function formatBillingProvider(provider: string | null | undefined): string {
  if (!provider) return 'Unbound';
  return provider.charAt(0).toUpperCase() + provider.slice(1);
}
